/**
 * Resolves a folder reference from API responses: either an ObjectId string
 * or a populated { _id, ... } object. Prevents "[object Object]" in URLs.
 */
export function normalizeFolderId(folderRef) {
  if (folderRef == null || folderRef === "") return null;
  if (typeof folderRef === "object") {
    if (folderRef._id == null) return null;
    return String(folderRef._id);
  }
  return String(folderRef);
}
